import * as React from "react";
import { useState as useComfortState } from "../../../context/reports/comfort";
import { Portfolio } from "context/reports/comfort/types";
import { ZonesFrame } from "./components/ZonesFrame";
import SeriesFrame from "./components/SeriesFrame";

interface PortFolioType {
  siteId: string;
  portfolio?: Portfolio;
}

export const ComfortZones = React.memo<PortFolioType>(
  ({ siteId }) => {
    const state = useComfortState();

    // ! TODO: Remove below when comfort api response is fixed
    const dataTimeRange = {
      from: "",
      to: "",
    };

    if (state.portfolio && state.portfolio[siteId]) {
      dataTimeRange.from = state.portfolio[siteId].summary.current.from;
      dataTimeRange.to = state.portfolio[siteId].summary.current.to;
    }
    // ! END TODO

    // ! TODO: Uncomment when comfort api response is fixed
    // const dataTimeRange = {
    //   from: state.zones ? state.zones.current.from : state.current.from,
    //   to: state.zones ? state.zones.current.to : state.current.to
    // }
    // ! END TODO

    return (
      <>
        <SeriesFrame
          portfolio={state.portfolio}
          portfolioLoading={state.portfolioLoading}
          siteId={siteId}
          rankDir={state.rankDir}
        />

        <ZonesFrame
          viewBy={state.viewBy}
          rankDir={state.rankDir}
          siteId={siteId}
          current={dataTimeRange}
          zonesLoading={state.zonesLoading}
          zones={state.zones}
        />
      </>
    );
  },
  (p, n) => p.siteId === n.siteId
);
